import React, { Component } from 'react';

export default class WebsiteWrapper extends Component {
	render() {
		const bodySkin = `${this.props.className} body-con`;
		return (
			<div className="body">
				<div className={bodySkin}>{this.props.children}</div>
				<div className="body-logo">
					<div>
						<img src={require('../../images/logo.png')} style={{ height: '6vh' }} />
						<span style={{ position: 'relative', bottom: '7px', right: '4px' }}>Ceries</span>
					</div>
				</div>
			</div>
		);
	}
}
